import { isUxMetrocorpImprovementsEnabled } from "util/v3ShellLayoutSync";

export const METROCORP_HOLDINGS_V3_PATH = "/v3/metrocorp";
export const METROCORP_SOAP_PATH = "/metrocorp";

export function isMetrocorpEscoMvp1Enabled() {
    return isUxMetrocorpImprovementsEnabled();
}

export function getMetrocorpConsultPath() {
    return isMetrocorpEscoMvp1Enabled() ? METROCORP_HOLDINGS_V3_PATH : METROCORP_SOAP_PATH;
}
